import ClaimsIconB from '../../assets/ServiceNavBarIcon/ClaimsIconB.svg';
import ClaimsIconW from '../../assets/ServiceNavBarIcon/ClaimsIconW.svg';
import MyJobsIconB from '../../assets/ServiceNavBarIcon/MyJobsIconB.svg';
import MyJobsIconW from '../../assets/ServiceNavBarIcon/MyJobsIconW.svg';
import CompanyProfileB from '../../assets/ServiceNavBarIcon/CompanyProfileB.svg';
import CompanyProfileW from '../../assets/ServiceNavBarIcon/CompanyProfileW.svg';
import PostDispatchEntitlementIconW from '../../assets/ServiceNavBarIcon/PostDispatchEntitlement.svg';
import PostDispatchEntitlementIconB from '../../assets/Vector.svg';
import EntitlementB from '../../assets/EntitlementB.svg';
import EntitlementW from '../../assets/EntitlementW.svg';
import FileIconB from '../../assets/ServiceNavBarIcon/fileIconB.svg';
import FileIconW from '../../assets/ServiceNavBarIcon/fileIconW.svg';
import AllJobsB from '../../assets/ServiceNavBarIcon/AllJobsB.svg';
import AllJobsW from '../../assets/ServiceNavBarIcon/AllJobsW.svg';

let keyCloakLoginToken = localStorage?.getItem('keyCloakLoginToken');

let dashboardUrl = `${
  process.env.REACT_APP_CLAIMS_URL
}/dashboard?access_token=${keyCloakLoginToken ? keyCloakLoginToken : ''}`;

export const getMenuItems = (fileClaimWithoutJob, isPsp, selfServicingDealer,provider) => [
  {
    key: '1',
    title: 'Company Profile',
    path: '/companyProfile',
    Icon: [CompanyProfileB, CompanyProfileW],
    show: true,
    children: [],
  },
  {
    key: '2',
    title: 'Jobs',
    path: '/allJobs',
    Icon: [MyJobsIconB, MyJobsIconW],
    show: true,
    children: [
      {
        key: '2.1',
        title: 'My Jobs',
        path: '/allJobs',
        Icon: [AllJobsB, AllJobsW],
        show: true,
      },
      {
        key: '2.2',
        title: 'Post Dispatch Create',
        path: '/create/jobNumber',
        Icon: [PostDispatchEntitlementIconB, PostDispatchEntitlementIconW],
        show: fileClaimWithoutJob && isPsp && !provider.isSamsung ,
      },
      {
        key: '2.3',
        title: 'Post Dispatch Upload',
        Icon: [EntitlementB, EntitlementW],
        path: '/postDispatch/uploadedFiles',
        show: isPsp ? selfServicingDealer || fileClaimWithoutJob : selfServicingDealer && fileClaimWithoutJob,
      },
      {
        key: '2.4',
        title: 'Claim Upload',
        Icon: [FileIconB, FileIconW],
        path: '/claim/upload',
        show: !provider.isSamsung,
        children: [],
      },
    ],
  },
  {
    key: '3',
    title: 'Claims',
    Icon: [ClaimsIconB, ClaimsIconW],
    isUrl: dashboardUrl,
    show: true,
    children: [],
  },
];
